$(function() {
  
  $('.block-slick-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 1000,
    dots: false,
    arrows: true,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='../images/shoe_story/arrow-left.png'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='../images/shoe_story/arrow-right.png'>"
  });

  $('.modal').on('hidden.bs.modal', function (e) {
    $iframe = $(this).find("iframe");
    $iframe.attr("src", $iframe.attr("src"));
  });
  
});


